// Site configuration and data
export const SITE_CONFIG = {
  phone: "+33 6 11 80 47 92",
  phoneLink: "tel:+33611804792",
  whatsappLink: "https://wa.me/33611804792",
  email: "svitshoti@gmail.com",
  companyName: "VS Riviera Conciergerie",
};

export const CITIES = [
  { id: "saint-raphael", nameFr: "Saint-Raphaël", nameEn: "Saint-Raphaël", slug: "saint-raphael" },
  { id: "frejus", nameFr: "Fréjus", nameEn: "Fréjus", slug: "frejus" },
  { id: "sainte-maxime", nameFr: "Sainte-Maxime", nameEn: "Sainte-Maxime", slug: "sainte-maxime" },
  { id: "cannes", nameFr: "Cannes", nameEn: "Cannes", slug: "cannes" },
  { id: "roquebrune", nameFr: "Roquebrune-sur-Argens", nameEn: "Roquebrune-sur-Argens", slug: "roquebrune-sur-argens" },
  { id: "les-issambres", nameFr: "Les Issambres", nameEn: "Les Issambres", slug: "les-issambres" },
];

export const SERVICES_FR = [
  {
    id: "nettoyage-appartement",
    slug: "nettoyage-appartement",
    title: "Nettoyage Appartement",
    shortTitle: "Nettoyage & Ménage",
    description: "Service de nettoyage professionnel pour appartements",
    longDescription: "Service de nettoyage professionnel pour villas, appartements et propriétés de luxe",
    features: ["Nettoyage ponctuel", "Ménage régulier", "Nettoyage en profondeur", "Standards haut de gamme"],
    icon: "sparkles",
  },
  {
    id: "nettoyage-villa",
    slug: "nettoyage-villa",
    title: "Nettoyage Villa",
    shortTitle: "Nettoyage Villa",
    description: "Nettoyage professionnel de villas de luxe",
    longDescription: "Service complet de nettoyage pour villas et propriétés de prestige sur la Côte d'Azur",
    features: ["Nettoyage complet", "Entretien piscine", "Jardinage", "Service sur mesure"],
    icon: "home",
  },
  {
    id: "menage-airbnb",
    slug: "menage-airbnb",
    title: "Ménage Airbnb",
    shortTitle: "Gestion Locative & Airbnb",
    description: "Service de ménage entre deux locations Airbnb",
    longDescription: "Gestion complète de votre propriété locative et optimisation Airbnb",
    features: ["Gestion Airbnb", "Accueil des locataires", "Entretien régulier", "Maximisation des revenus"],
    icon: "key",
  },
  {
    id: "nettoyage-apres-chantier",
    slug: "nettoyage-apres-chantier",
    title: "Nettoyage Après Chantier",
    shortTitle: "Nettoyage Chantier",
    description: "Nettoyage professionnel après travaux de construction",
    longDescription: "Service spécialisé de nettoyage après rénovation ou construction",
    features: ["Évacuation gravats", "Nettoyage poussière", "Lavage vitres", "Remise en état"],
    icon: "hammer",
  },
  {
    id: "nettoyage-fin-location",
    slug: "nettoyage-fin-location",
    title: "Nettoyage Fin de Location",
    shortTitle: "Fin de Location",
    description: "Nettoyage complet pour restitution de bail",
    longDescription: "Service de nettoyage approfondi pour récupérer votre caution",
    features: ["État des lieux impeccable", "Nettoyage complet", "Récupération caution", "Délais rapides"],
    icon: "clipboard",
  },
  {
    id: "conciergerie-airbnb",
    slug: "conciergerie-airbnb",
    title: "Conciergerie Airbnb",
    shortTitle: "Services Conciergerie",
    description: "Service complet de conciergerie pour locations",
    longDescription: "Services personnalisés de conciergerie pour une expérience exclusive",
    features: ["Courses et livraisons", "Réservations", "Services sur mesure", "Disponibilité 7j/7"],
    icon: "concierge",
  },
];

export const SERVICES_EN = [
  {
    id: "apartment-cleaning",
    slug: "apartment-cleaning",
    title: "Apartment Cleaning",
    shortTitle: "Cleaning & Housekeeping",
    description: "Professional cleaning service for apartments",
    longDescription: "Professional cleaning service for villas, apartments and luxury properties",
    features: ["One-time cleaning", "Regular housekeeping", "Deep cleaning", "High-end standards"],
    icon: "sparkles",
  },
  {
    id: "villa-cleaning",
    slug: "villa-cleaning",
    title: "Villa Cleaning",
    shortTitle: "Villa Cleaning",
    description: "Professional cleaning of luxury villas",
    longDescription: "Complete cleaning service for villas and prestigious properties on the French Riviera",
    features: ["Complete cleaning", "Pool maintenance", "Gardening", "Tailored service"],
    icon: "home",
  },
  {
    id: "airbnb-cleaning",
    slug: "airbnb-cleaning",
    title: "Airbnb Cleaning",
    shortTitle: "Property & Airbnb Management",
    description: "Turnover cleaning service between Airbnb rentals",
    longDescription: "Complete management of your rental property and Airbnb optimization",
    features: ["Airbnb management", "Guest welcome", "Regular maintenance", "Revenue maximization"],
    icon: "key",
  },
  {
    id: "post-construction-cleaning",
    slug: "post-construction-cleaning",
    title: "Post Construction Cleaning",
    shortTitle: "Post Construction",
    description: "Professional cleaning after construction work",
    longDescription: "Specialized cleaning service after renovation or construction",
    features: ["Debris removal", "Dust cleaning", "Window washing", "Property restoration"],
    icon: "hammer",
  },
  {
    id: "end-of-rental-cleaning",
    slug: "end-of-rental-cleaning",
    title: "End of Rental Cleaning",
    shortTitle: "End of Rental",
    description: "Complete cleaning for lease termination",
    longDescription: "Thorough cleaning service to recover your security deposit",
    features: ["Impeccable inspection", "Complete cleaning", "Deposit recovery", "Fast turnaround"],
    icon: "clipboard",
  },
  {
    id: "airbnb-concierge",
    slug: "airbnb-concierge",
    title: "Airbnb Concierge",
    shortTitle: "Concierge Services",
    description: "Complete concierge service for rentals",
    longDescription: "Personalized concierge services for an exclusive experience",
    features: ["Shopping & deliveries", "Reservations", "Tailored services", "24/7 availability"],
    icon: "concierge",
  },
];

export const TESTIMONIALS = [
  {
    text: "Service impeccable ! Équipe professionnelle et discrète. Je recommande vivement pour le nettoyage et la gestion Airbnb.",
    textEn: "Impeccable service! Professional and discreet team. Highly recommend for cleaning and Airbnb management.",
    name: "Marie L.",
    location: "Saint-Raphaël",
    service: "Gestion Airbnb",
    serviceEn: "Airbnb Management",
  },
  {
    text: "Excellente conciergerie. Réactivité exceptionnelle, produits écologiques, rapport qualité-prix imbattable.",
    textEn: "Excellent concierge service. Exceptional responsiveness, eco-friendly products, unbeatable value.",
    name: "Pierre D.",
    location: "Cannes",
    service: "Conciergerie Premium",
    serviceEn: "Premium Concierge",
  },
  {
    text: "Service de qualité, toujours impeccable et ponctuelle. Notre maison brille ! Prix raisonnable.",
    textEn: "Quality service, always impeccable and punctual. Our house shines! Reasonable prices.",
    name: "Sophie M.",
    location: "Fréjus",
    service: "Ménage Régulier",
    serviceEn: "Regular Cleaning",
  },
  {
    text: "Résultat parfait en temps record. Équipe professionnelle et efficace. Notre référence pour tout nettoyage.",
    textEn: "Perfect results in record time. Professional and efficient team. Our reference for all cleaning.",
    name: "Jean-Claude M.",
    location: "Sainte-Maxime",
    service: "Nettoyage Villa",
    serviceEn: "Villa Cleaning",
  },
  {
    text: "Service exceptionnel, discrétion absolue, disponibles 24/7. Ils s'occupent de tout avec excellence.",
    textEn: "Exceptional service, absolute discretion, available 24/7. They handle everything with excellence.",
    name: "Isabella R.",
    location: "Les Issambres",
    service: "Conciergerie Luxe",
    serviceEn: "Luxury Concierge",
  },
  {
    text: "Gestion Airbnb parfaite. Communication excellente, nettoyage impeccable. Très satisfait du service.",
    textEn: "Perfect Airbnb management. Excellent communication, impeccable cleaning. Very satisfied with the service.",
    name: "Laurent B.",
    location: "Cannes",
    service: "Gestion Airbnb",
    serviceEn: "Airbnb Management",
  },
];

export const FAQ_FR = [
  {
    question: "Combien coûte un service de nettoyage à Saint-Raphaël ?",
    answer: "Nos tarifs varient selon la surface et le type de prestation. Contactez-nous pour un devis gratuit personnalisé. Nous proposons des forfaits adaptés à tous les budgets avec un excellent rapport qualité-prix.",
  },
  {
    question: "Proposez-vous un service de ménage régulier à Fréjus ?",
    answer: "Oui, nous proposons des services de ménage hebdomadaire, bi-mensuel ou mensuel à Fréjus et dans toute la région. Nos équipes sont formées pour maintenir votre propriété dans un état impeccable.",
  },
  {
    question: "Comment fonctionne la gestion Airbnb à Cannes ?",
    answer: "Nous gérons intégralement votre location : création d'annonces optimisées, gestion des réservations, accueil des voyageurs, ménage entre les séjours, et communication avec les clients. Maximisez vos revenus sans stress.",
  },
  {
    question: "Intervenez-vous pour le nettoyage de villas à Sainte-Maxime ?",
    answer: "Absolument ! Nous sommes spécialisés dans le nettoyage de villas de luxe à Sainte-Maxime. Nos équipes expérimentées s'adaptent à toutes les surfaces et prestations haut de gamme.",
  },
  {
    question: "Quels services de conciergerie proposez-vous ?",
    answer: "Notre service de conciergerie comprend : courses et livraisons, réservations de restaurants et activités, transferts aéroport, organisation d'événements, et tout service sur mesure pour faciliter votre séjour.",
  },
  {
    question: "Êtes-vous disponible pour un nettoyage d'urgence ?",
    answer: "Oui, nous proposons des interventions d'urgence 7j/7. Contactez-nous par téléphone ou WhatsApp pour une réponse rapide. Nous ferons tout notre possible pour intervenir dans les plus brefs délais.",
  },
  {
    question: "Utilisez-vous des produits écologiques pour le ménage ?",
    answer: "Oui, nous privilégions les produits écologiques et respectueux de l'environnement. Sur demande, nous pouvons utiliser exclusivement des produits bio certifiés pour votre propriété.",
  },
  {
    question: "Comment obtenir un devis de nettoyage gratuit ?",
    answer: "Remplissez notre formulaire de contact ou appelez-nous directement. Nous vous répondrons sous 24h avec un devis détaillé et transparent, sans engagement de votre part.",
  },
];

export const FAQ_EN = [
  {
    question: "How much does cleaning service cost in Saint-Raphaël?",
    answer: "Our rates vary depending on the surface area and type of service. Contact us for a free personalized quote. We offer packages adapted to all budgets with excellent value for money.",
  },
  {
    question: "Do you offer regular housekeeping service in Fréjus?",
    answer: "Yes, we offer weekly, bi-weekly or monthly housekeeping services in Fréjus and throughout the region. Our teams are trained to maintain your property in impeccable condition.",
  },
  {
    question: "How does Airbnb management work in Cannes?",
    answer: "We fully manage your rental: optimized listing creation, booking management, guest welcome, cleaning between stays, and client communication. Maximize your income stress-free.",
  },
  {
    question: "Do you clean villas in Sainte-Maxime?",
    answer: "Absolutely! We specialize in luxury villa cleaning in Sainte-Maxime. Our experienced teams adapt to all surfaces and high-end services.",
  },
  {
    question: "What concierge services do you offer?",
    answer: "Our concierge service includes: shopping and deliveries, restaurant and activity reservations, airport transfers, event organization, and any custom service to facilitate your stay.",
  },
  {
    question: "Are you available for emergency cleaning?",
    answer: "Yes, we offer emergency interventions 7 days a week. Contact us by phone or WhatsApp for a quick response. We will do everything possible to intervene as soon as possible.",
  },
  {
    question: "Do you use eco-friendly products for cleaning?",
    answer: "Yes, we favor eco-friendly and environmentally friendly products. On request, we can use exclusively certified organic products for your property.",
  },
  {
    question: "How can I get a free cleaning quote?",
    answer: "Fill out our contact form or call us directly. We will respond within 24 hours with a detailed and transparent quote, with no obligation on your part.",
  },
];
